import { isHtml } from '@PROJECT_ROOT/assets/shared/js/isPartnerService';

$(() => {
    $(document).scroll((e) => {
        e.preventDefault();
    });

    const unitLinks = $('.serviceUnitLink');
    const unitHeaders = $('.servicesUnitTitle');
    const unitContents = $('.servicesUnitContent');
    const tmpUnitTitle = $('#tmpUnitTitle');
    const jScrollPaneAPI = $('#galleryMenuList').data('jsp');

    function closeAllUnits() {
        unitLinks.removeClass('active');
        unitContents.hide();
        unitHeaders.removeClass('opened').data('opened', false);
    }

    function slideUpAllUnits() {
        unitLinks.removeClass('active');
        unitContents.slideUp();
        unitHeaders.removeClass('opened').data('opened', false);
    }

    unitLinks.each(function attachEventHandlerToLink(i) {
        const tmpThis = $(this);
        tmpThis.on('click', (e) => {
            e.preventDefault();
            closeAllUnits();
            $(unitHeaders[i]).click();
            const unitTop = $(unitHeaders[i]).offset().top;
            $('html,body').animate({ scrollTop: unitTop }, 1000);
        });
    });

    unitHeaders.each(function doForEach(i) {
        const tmpThis = $(this);
        const theUnitTitle = tmpThis.attr('data-label');
        const theUnitHeader = tmpThis.attr('data-title');
        tmpThis.data('opened', false).on('click', (e) => {
            if (e.originalEvent) {
                if (!tmpThis.data('opened')) {
                    slideUpAllUnits();
                    $(unitContents[i]).slideDown();
                    // scroll menu to selected unit
                    jScrollPaneAPI.scrollToElement($(unitLinks[i]).addClass('active').parent());
                    tmpThis.addClass('opened').data('opened', true);
                    tmpUnitTitle.text(`| ${theUnitHeader}`);
                    window.location.hash = theUnitTitle;
                } else {
                    $(unitContents[i]).slideUp();
                    $(unitLinks[i]).removeClass('active');
                    tmpThis.removeClass('opened').data('opened', false);
                    tmpUnitTitle.text('');
                    window.location.hash = 'object';
                }
            } else if (!tmpThis.data('opened')) {
                // scroll menu to selected unit
                jScrollPaneAPI.scrollToElement($(unitLinks[i]).addClass('active').parent());
                $(unitContents[i]).show();
                tmpThis.addClass('opened').data('opened', true);
                tmpUnitTitle.text(`| ${theUnitHeader}`);
                window.location.hash = theUnitTitle;
            }

            const linkElement = document.getElementById('reservationChangeable');
            if (linkElement !== null) {
                let unitId = '';

                // ovo je posebno za lighthouse uvjet jer je njemu theUnitTitle npr. ST-14-b, a treba nam id unita
                if (tmpThis.attr('data-lighthouse-unit') !== undefined) {
                    unitId = tmpThis.attr('data-lighthouse-unit');
                }

                // Html servis
                if (isHtml()) {
                    if (linkElement.href.indexOf('/unit/') !== -1) {
                        linkElement.href = linkElement.href.replace(/unit\/\d*/gi, `unit/${unitId}`);
                    } else {
                        const unitReservationButton = document.getElementById(`reservationUnit_${unitId}`);
                        if (unitReservationButton) {
                            linkElement.href = unitReservationButton.href;
                        }
                    }

                    return;
                }

                // Naš site i frame
                const pathnameArray = linkElement
                    .pathname
                    .replace(/unit\/\d*$/gi, '') // uklanjamo unit/unitId dio
                    .split('/')
                    .filter((fragment) => !!fragment); // uklanjamo prazne elemente
                pathnameArray.push('unit');
                pathnameArray.push(unitId);

                linkElement.href = `${linkElement.protocol}//${linkElement.hostname}/${pathnameArray.join('/')}${linkElement.search}${linkElement.hash}`;
            }
        });
    });

    // ako je postavljena jedinica, otvara se prikaz za tu jedinicu;
    // inače se otvara prva jedinica iz objekta
    if (window.location.hash) {
        const tmpUnit = `.servicesUnitTitle[data-label=${window.location.hash.substr(1)}]`;
        $(tmpUnit).click();
    } else if (unitHeaders.length > 0) {
        unitHeaders[0].click();
    }
});
